class SideDrawer extends HTMLElement {
  connectedCallback() {
    this.activeElement = null;

    if (this.hasAttribute('data-global-scope') && !this._globalScope) {
      this._globalScope = true;
      this.setAttribute('hidden', '');
      document.body.appendChild(this);
      this.removeAttribute('hidden');
      return;
    }

    this.render();
  }

  render() {
    const content = this.innerHTML;
    const headingElement = this.querySelector('[data-side-drawer-heading]');
    const headingId = headingElement?.id;

    this.innerHTML = `
      <div class="side-drawer__overlay"></div>
      <div
        class="side-drawer__inner"
        role="dialog"
        aria-modal="true"
        ${headingId ? `aria-labelledby="${headingId}"` : ''}
        tabindex="-1"
      >
        <button class="side-drawer__close" type="button" aria-label="${'Close ' + headingElement.textContent.trim()}">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path d="M17.0495 2.93823C17.4672 2.52059 18.1441 2.52059 18.5618 2.93823C18.9794 3.35587 18.9794 4.03285 18.5618 4.45048L12.5117 10.4995L18.5618 16.5495C18.9794 16.9671 18.9792 17.6441 18.5618 18.0618C18.1441 18.4794 17.4672 18.4794 17.0495 18.0618L10.9995 12.0117L4.95048 18.0618C4.53285 18.4794 3.85587 18.4794 3.43823 18.0618C3.02059 17.6441 3.02059 16.9672 3.43823 16.5495L9.48723 10.4995L3.43823 4.45048C3.02059 4.03284 3.02059 3.35587 3.43823 2.93823C3.85588 2.52075 4.53289 2.52064 4.95048 2.93823L10.9995 8.98723L17.0495 2.93823Z" fill="white"/>
          </svg>
        </button>
        <div data-content>${content}</div>
      </div>
    `;

    this.initEvents();
  }

  initEvents() {
    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close(),
    );

    this.querySelector('.side-drawer__overlay').addEventListener(
      'click',
      this.close.bind(this),
    );
    this.querySelector('.side-drawer__close').addEventListener(
      'click',
      this.close.bind(this),
    );

    if (this.id) {
      document
        .querySelectorAll(`[data-drawer-target="${this.id}"]`)
        .forEach((element) => {
          element.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(event.currentTarget);
          });
        });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    } else if (!this.activeElement || !this.activeElement.isConnected) {
      this.setActiveElement(document.activeElement);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('side-drawer-open');
    });

    this.setPageAccessibility(true);

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.side-drawer__close');
        trapFocus(this.querySelector('.side-drawer__inner'), focusElement);
      },
      {once: true},
    );
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus();
    this.setPageAccessibility(false);
    document.body.classList.remove('side-drawer-open');

    const target = this.activeElement;
    if (target && target.isConnected && !target.hasAttribute('disabled')) {
      requestAnimationFrame(() => target.focus());
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setPageAccessibility(isOpen) {
    const parent = this.parentElement;
    if (!parent) return;

    const siblings = Array.from(parent.children).filter((child) => {
      if (child === this) return false;
      const tagName = child.tagName?.toLowerCase();
      return tagName !== 'style' && tagName !== 'script';
    });

    siblings.forEach((sibling) => {
      if (isOpen) {
        if (!sibling.hasAttribute('inert')) {
          sibling.setAttribute('inert', '');
          sibling.dataset.sideDrawerInert = 'true';
        }
      } else {
        if (sibling.dataset.sideDrawerInert === 'true') {
          sibling.removeAttribute('inert');
          delete sibling.dataset.sideDrawerInert;
        }
      }
    });
  }
}

if (!customElements.get('side-drawer')) {
  customElements.define('side-drawer', SideDrawer);
}
